export default "__VITE_ASSET__BN6Po6EN__"